import { defineMessages } from 'react-intl';

export default defineMessages({
  btn: {
    cancel: {
      id: 'formBuilder.btn.cancel',
      defaultMessage: 'Cancel',
    },
    delete: {
      id: 'formBuilder.btn.delete',
      defaultMessage: 'Delete',
    },
    return: {
      id: 'formBuilder.btn.return',
      defaultMessage: 'Return',
    },
  },
  error: {
    delete: {
      id: 'formBuilder.error.delete',
      defaultMessage:
        'This form cannot be deleted as this form is still assigned to some service(s) and/or biller(s)',
    },
  },
  confirmation: {
    title: {
      id: 'formBuilder.confirmation.title',
      defaultMessage: 'Confirmation',
    },
    delete: {
      id: 'formBuilder.confirmation.delete',
      defaultMessage: 'Are you sure want to delete {title} form?',
    },
  },
});
